import { BaseAnalysisEngine } from "./baseAnalysisEngine";
import { Mi1Engine } from "./mi1Engine";
import { Mi2Engine } from "./mi2Engine";
import { Mi21Engine } from "./mi2_1Engine";
import { Co1Engine } from "./co1Engine";
import { Co2Engine } from "./co2Engine";
import { Co21Engine } from "./co2_1Engine";
import { Sl1Engine } from "./sl1Engine";

// import { CogEngine } from "./cogEngine";
// import { Np1Engine } from "./np1Engine";
// import { DysphagiaEngine } from "./dysphagiaEngine";
// import { Br1Engine } from "./br1Engine";

import {
  AnalysisEngineType,
  EngineType,
  SupportedAnalysisEngineType,
  engineTypes,
} from "../types";

function createEngine(
  engineType: EngineType,
  analysisType: AnalysisEngineType,
): BaseAnalysisEngine<unknown> {
  const props = { _analysisType: analysisType };
  switch (engineType) {
    case "mi1":
      return new Mi1Engine();
    case "mi2":
      return new Mi2Engine(props);
    case "mi2.1":
      return new Mi21Engine(props);
    case "co1":
      return new Co1Engine(props);
    case "co2":
      return new Co2Engine(props);
    case "co2.1":
      return new Co21Engine();
    case "sl1":
      return new Sl1Engine(props);
    // NOTE: VOISLOG非対応エンジン
    // case "cog":
    //   return new CogEngine(props);
    // case "np1":
    //   return new Np1Engine();
    // case "dysphagia":
    //   return new DysphagiaEngine();
    // case "br1":
    //   return new Br1Engine();
    default:
      throw new Error(`Unknown engine type: ${engineType}`);
  }
}

export function createEngines(
  analysisType: SupportedAnalysisEngineType,
): BaseAnalysisEngine<unknown>[] {
  const config = engineTypes[analysisType];
  return config.engines.map((et) => createEngine(et, analysisType));
}
